var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4233 1.09583C15.3218 0.851481 15.1277 0.657305 14.8833 0.55583C14.7631 0.504589 14.634 0.47741 14.5033 0.47583H4.50332C4.2381 0.47583 3.98375 0.581187 3.79621 0.768723C3.60868 0.95626 3.50332 1.21061 3.50332 1.47583C3.50332 1.74105 3.60868 1.9954 3.79621 2.18294C3.98375 2.37047 4.2381 2.47583 4.50332 2.47583H12.0933L0.791892 13.8083C0.698164 13.9013 0.62377 14.0119 0.573001 14.1338C0.522232 14.2556 0.496094 14.3863 0.496094 14.5183C0.496094 14.6503 0.522232 14.781 0.573001 14.9029C0.62377 15.0248 0.698164 15.1354 0.791892 15.2283C0.884855 15.3221 0.995456 15.3965 1.11732 15.4472C1.23917 15.498 1.36988 15.5241 1.50189 15.5241C1.6339 15.5241 1.76461 15.498 1.88647 15.4472C2.00833 15.3965 2.11893 15.3221 2.21189 15.2283L13.5033 3.88583V11.4758C13.5033 11.741 13.6087 11.9954 13.7962 12.1829C13.9838 12.3705 14.2381 12.4758 14.5033 12.4758C14.7685 12.4758 15.0229 12.3705 15.2104 12.1829C15.398 11.9954 15.5033 11.741 15.5033 11.4758V1.47583C15.5017 1.34515 15.4746 1.21605 15.4233 1.09583Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.f21c1fa078ce497929adda1a7b0b69b3.svg";
export { ForwardRef as ReactComponent };